import { Component, Input, OnInit } from '@angular/core';
import { Chart } from 'angular-highcharts';
// import * as Highcharts from 'highcharts';
// declare var require: any

// require('highcharts/modules/exporting')(Highcharts);
// require('highcharts/modules/export-data')(Highcharts);
// require('highcharts/modules/annotations')(Highcharts);
// // require('highcharts/modules/solid-gauge')(Highcharts);
// // require('highcharts/modules/solid-gauge.src')(Highcharts);
// require('highcharts/highcharts');

import * as Highcharts from 'highcharts/highcharts';
import * as HighchartsMore from 'highcharts/highcharts-more';
import { color } from 'highcharts/highcharts.src';
import * as HighchartsSolidGauge from 'highcharts/modules/solid-gauge';
// HighchartsMore(Highcharts);
// HighchartsSolidGauge(Highcharts);

@Component({
  selector: 'app-lfsa-gh-dual-axes',
  templateUrl: './lfsa-gh-dual-axes.component.html',
  styleUrls: ['./lfsa-gh-dual-axes.component.css']
})
export class LfsaGhDualAxesComponent implements OnInit {

  @Input() title: any;

  // @Input() loading: boolean = false;
  @Input() idComponent: string;

  @Input() titlesX: string[];

  @Input() dataY1: any[];
  @Input() unidadY1: string;
  @Input() unidadTextY1: string;

  @Input() dataY2: any[];
  @Input() unidadY2: string;
  @Input() unidadTextY2: string;

  @Input() listVmiAmortverde: number[] = [];
  @Input() listVmiAmortamarillo: number[] = [];
  @Input() listVmiAmortrojo: any[] = [];

  chart: Chart;

  constructor() { }

  ngOnInit(): void {
    this.init();
  }

  init() {
    let objSetting: any = {
      chart: {
        zoomType: 'xy',
        height: '40%'
      },
      title: {
        text: this.title,
        align: 'center'
      },
      subtitle: {
        text: ''
      },
      xAxis: [{
        categories: this.titlesX,
        crosshair: true,
      }],
      yAxis: [
        { // Secondary yAxis
          labels: {
            format: `{value} ${this.unidadY2}`,
            style: {
              color: Highcharts.getOptions().colors[1]
            }
          },
          title: {
            text: `${this.unidadTextY2}`,
            style: {
              color: Highcharts.getOptions().colors[1]
            }
          },
          opposite: true,
          reversed: true,
          min: 0,
          max: 100,
        },
        { // Primary yAxis
          labels: {
            format: `{value}${this.unidadY1}`,
            style: {
              color: Highcharts.getOptions().colors[0]
            },
          },
          title: {
            text: `${this.unidadTextY1}`,
            style: {
              color: Highcharts.getOptions().colors[0]
            }
          },
          min: 0,
          max: 100000,
        }

      ],
      tooltip: {
        shared: true
      },
      legend: {
        align: 'left',
        x: 80,
        verticalAlign: 'top',
        y: 80,
        floating: true,
        backgroundColor:
          Highcharts.defaultOptions.legend.backgroundColor || // theme
          'rgba(255,255,255,0.25)'
      },
      series: [
        {
          name: this.unidadTextY1,
          type: 'column',
          yAxis: 1,
          data: this.dataY1,
          tooltip: {
            valueSuffix: ` ${this.unidadY1}`

          }
        },
        {
          name: this.unidadTextY2,
          type: 'spline',
          data: this.dataY2,
          tooltip: {
            valueSuffix: ` ${this.unidadY2}`
          }
        }]
    }
    // debugger
    let lista = [];
    for (let i = 0; i < this.listVmiAmortrojo.length; i++) {
      // let r = 0;
      // if (i < 1) {
      //   r = this.listVmiAmortrojo[i];
      //   r = r * 2;
      // } else {
      //   r = this.listVmiAmortrojo[i];
      // }
      const r = this.listVmiAmortrojo[i];
      const v = this.listVmiAmortverde[i];
      const a = this.listVmiAmortamarillo[i];
      // lista = [];
      lista.push(
        {

          from: 0,
          to: r,
          color: '#FF6666',
          id: 'plot-band ' + i,
          // start: this.titlesX[0],
          // end: this.titlesX[1],
          // label: {
          //   text: `valor ${r}`
          // }
        },
        {
          from: r,
          to: a,
          color: '#FFFF99',
          id: 'plot-band ' + i,
          start: i,
          end: i + 1,
          // label: {
          //   text: `valor ${a}`
          // }
        },
        {
          from: a,
          to: v,
          color: '#99FF99',
          id: 'plot-band ' + i,
          start: i,
          end: i + 1,
          // label: {
          //   text: `valor ${v}`
          // }
        },
        {
          from: v,
          to: 100000,
          color: '#99CCFF',
          id: 'plot-band ' + i,
          start: i,
          end: i + 1,
          // label: {
          //   text: `valor ${r}`
          // }
        }
      );
      // objSetting.yAxis[1].plotBands[i] = lista;
      // if(i > 2) {
      //   break
      // }
    }
    objSetting.yAxis[1].plotBands = lista;
    let chart = new Chart(objSetting);
    this.chart = chart;
    chart.ref$.subscribe(console.log);
  }

}
